import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/Footer.css";
import { useCart } from "../context/CartContext";

const Footer = () => {
  const { toggleCart } = useCart();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/path-to-your-logo.png" alt="Logo" />
        </div>

        <div className="footer-section">
          <h3>INFORMATION</h3>
          <ul>
            <li>
              <Link to="/terms">Terms of Service</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/refund">Refund & Return Policy</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>LINKS</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link onClick={toggleCart}>Cart</Link>
            </li>
            <li>
              <Link to="/favourites">Wishlist</Link>
            </li>
            <li>
              <Link to="/FAQ">FAQ</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 ShineInLavender. All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
